import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import BreadcrumbList from "@/core/seo/json-ld/BreadcrumbList.vue";
import { useTranslations } from "@/core/translate.mixin";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import BreakpointService from "@/core/responsive/breakpoints/breakpoint.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbItem',
  setup(__props) {

const breadcrumb = computed<SitePath[]>(() => store.getters["app/breadcrumb"]);
const hideBreadcrumb = computed<boolean>(() => store.getters["app/hideBreadcrumb"]);
const previousUrlBreadcrumb = computed<boolean>(() => store.getters["app/previousUrlBreadcrumb"]);
const statusCode = computed<number>(() => store.getters["app/statusCode"]);
const hideNavigationSpacer = computed<boolean>(() => store.getters["app/hideNavigationSpacer"]);
const isCheckoutView = computed<boolean>(() => store.getters["app/isCheckoutView"]);
const showAuthTopBar = computed<boolean>(() => store.getters["app/showAuthTopBar"]);
const showEmptyTopBar = computed<boolean>(() => store.getters["app/showEmptyTopBar"]);
const portalRoot = computed<INavigationViewObject | null>(() => store.getters["app/portalRoot"]);
const usp = computed<IUsp>(() => store.getters["app/usp"]);
const selectedMode = computed<IMode>(() => store.getters["app/selectedMode"]);
const theme = computed<ColorTheme>(() => store.getters["app/theme"]);
const isCheckoutViewWithTopBar = computed<boolean>(() => store.getters["app/isCheckoutViewWithTopBar"]);
const customBreadcrumbStyling = computed<string>(() => store.getters["app/customBreadcrumbStyling"]);
const myAccountRoot = computed<INavigationViewObject | null>(() => store.getters["app/myAccountRoot"]);
const menuTheme = computed<MenuThemeSettings>(() => store.getters["app/menuTheme"]);

// const parentPage = ref<SitePath | null>(null);
const breadcrumbTextClass = "u-text-small u-whitespace-nowrap u-no-underline u-hidden lg:u-inline-block";
const customBreadcrumbColorClass = "custom-breadcrumb-color";
// const breadcrumbText = ref<string | null>(null);
const dynamicBreadcrumb = computed<boolean>(() => !isCheckoutView.value && !previousUrlBreadcrumb.value);

const showBreadcrumb = ref<boolean>(getShowBreadcrumb());

const { t } = useTranslations();

function getBreadcrumbText(page: SitePath): string {
    return statusCode.value === 404
        ? t("Pages.Error404.BreadcrumbText")
        : (showBreadcrumb.value && dynamicBreadcrumb.value ? page.displayName : null);
}

watch(breadcrumb, onBreadcrumbChanged);

const whiteText = computed<boolean>(() => {
    return menuTheme.value.whiteMenuText;
});

function onBreadcrumbChanged(): void {
    showBreadcrumb.value = getShowBreadcrumb();
    scrollToEnd();
}

function getShowBreadcrumb(): boolean {
    if (!dynamicBreadcrumb.value) return true;
    if (!breadcrumb.value || hideBreadcrumb.value) {
        return false;
    }

    const breadCrumbLength = breadcrumb.value.length;
    return breadCrumbLength > 1 || statusCode.value === 404;
}

const router = useRouter();
const route = useRoute();

const isMyAccountPage = myAccountRoot.value ? route.fullPath.includes(myAccountRoot.value.path) : false;

const activeBreakpoint = computed<string>(() => {
    return BreakpointService.getActiveBreakpoint();
});

const isLargeBreakpoint = computed<boolean>(() => {
    return activeBreakpoint.value.includes("large");
});

const showGoBackArrowAndLabel = !(isLargeBreakpoint.value) || isMyAccountPage || previousUrlBreadcrumb;

function goBack() {
    router.back();
}

function backToSite(): void {
    // hasChangedRoute ? $router.back() :
    router.push(selectedMode.value.frontpageUrl);
}

onMounted(() => {
    nextTick(() => {
        scrollToEnd();
    });
});

const itemContainer = ref(null);

function scrollToEnd(): void {
    setTimeout(() => {
        if (showBreadcrumb.value) {
            const container = itemContainer.value as HTMLElement;
            const rect = container.getBoundingClientRect();
            container.scrollLeft = rect.width;
        }
    }, 100);
}

const themeStyleContent = computed<string>(() => {
    const themeObject : any = { color: theme.value.breadcrumbColor, opacity: 0.6 };
    return `.${customBreadcrumbColorClass} {${Object.keys(themeObject).map(k => `${k}:${themeObject[k]}`).join("; ")}}`;
});

return { __sfc: true,breadcrumb, hideBreadcrumb, previousUrlBreadcrumb, statusCode, hideNavigationSpacer, isCheckoutView, showAuthTopBar, showEmptyTopBar, portalRoot, usp, selectedMode, theme, isCheckoutViewWithTopBar, customBreadcrumbStyling, myAccountRoot, menuTheme, breadcrumbTextClass, customBreadcrumbColorClass, dynamicBreadcrumb, showBreadcrumb, t, getBreadcrumbText, whiteText, onBreadcrumbChanged, getShowBreadcrumb, router, route, isMyAccountPage, activeBreakpoint, isLargeBreakpoint, showGoBackArrowAndLabel, goBack, backToSite, itemContainer, scrollToEnd, themeStyleContent, BreadcrumbList }
}

})